import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/material';
import Breadcrumb from 'src/components/Breadcrumb';
import getColorCode from 'src/utils/GetThemeColor';
import { ReactComponent as BreadcrumbIcon } from 'src/Images/icons/common/breadcrumbIcon.svg';
import { ReactComponent as RefreshIcon } from 'src/Images/icons/common/refresh.svg';

export default function HeaderSection({ vehicle }) {
  const isMobile = useMediaQuery('(max-width:767px)');
  const [showBreadcrumb, setShowBreadcrumb] = useState(false);
  const themeColor = useSelector(
    (state) => state.AuthReducer?.userData?.tenant?.theme,
  );
  const title = vehicle?.vehicleNumber || '';
  const statusName = vehicle?.status?.name;

  return (
    <div
      className={`div-flex-row div-space-between div-align-center ${
        isMobile ? 'mobile-vehicle-detail-header' : 'vehicle-detail-header'
      }`}
    >
      <div className="div-flex-row cg-10 div-align-center">
        <div
          className={`div-flex-row div-align-center ${
            showBreadcrumb ? 'cg-10' : 'cg-5'
          }`}
        >
          {!isMobile && (
            <div
              className={`breadcrumb-container div-flex-row cg-5 div-align-center ${
                showBreadcrumb ? 'breadcrumb-open' : ''
              }`}
            >
              {showBreadcrumb && <Breadcrumb />}

              <div
                role="button"
                tabIndex={0}
                aria-label="Toggle breadcrumb"
                className="footer-content-for-component div-align-center"
                onClick={() => setShowBreadcrumb((prev) => !prev)}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    setShowBreadcrumb((prev) => !prev);
                  }
                }}
              >
                <BreadcrumbIcon
                  className={`icon-size-xsm ${
                    showBreadcrumb ? 'rotate-icon-180' : ''
                  }`}
                  color="#9F9F9F"
                />
              </div>
            </div>
          )}

          <span className="text-xl-outfit text-semi-bold">
            {title || '-/-'}
          </span>
        </div>

        {statusName && (
          <div className="div-align-center">
            <div className="vehicle-status-pill status-pill-container">
              <span className="text-sm-outfit text-medium-bold">
                {statusName}
              </span>
            </div>
          </div>
        )}
      </div>

      {!isMobile && (
        <button
          type="button"
          className="icon-btn-none div-align-center"
          aria-label="Refresh vehicle details"
          onClick={() => window.location.reload()}
        >
          <RefreshIcon
            className="icon-size-xl"
            color={getColorCode(themeColor)}
          />
        </button>
      )}
    </div>
  );
}
